import { IFormationsPreviewDocument } from "./FilePreviewComponent/FilePreviewComponent";

export const readCountShouldIncrease = (currentFile: IFormationsPreviewDocument | undefined, isAdmin: boolean, isAdminSpoof: boolean, accountId: string) => {
    // if user is not admin and not spoofing customer and the file is not undefined and is not uploaded by the user then increase read count
    if (!isAdmin && !isAdminSpoof && currentFile && currentFile?.uploader.accountId !== accountId) {
        return true;
    } 
    return false; 
}